export const isExternalUrl = (url) =>
  !!(
    url?.match(/^http/i) &&
    !url.match(new RegExp(`^http(s)?://${window.location.hostname}`), 'i')
  );
